export const META_PIXEL_ID = '1456674855666673'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return
  if ((window as any).fbq) return

  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  ;(window as any).fbq = n
  if (!(window as any)._fbq) (window as any)._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  ;(window as any).fbq('init', META_PIXEL_ID)
}

export const trackPageView = () => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('trackSingle', META_PIXEL_ID, 'PageView')
  }
}

export const trackAddToCart = (data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('trackSingle', META_PIXEL_ID, 'AddToCart', data)
  }
}
